import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../icons/icon'
import logo from '../../styles/images/logo-white.svg'
import { Link } from 'react-router-dom'

const MainMenuButton = ({ onClick }) => (
  <button className='nav-button' onClick={onClick}>
    <span className='icon icon-menu' />
  </button>
)

const Logo = () => (
  <div className='header-logo'>
    <Link to='/explore'>
      <img src={logo} alt='Chairbids Logo' />
    </Link>
  </div>
)

function getBubbleState(badItemsCount) {
  return !!badItemsCount ? 'error' : 'success'
}

const NotificationsButton = ({ totalCount, bubbleState, onClick }) => (
  <button className='action' onClick={onClick}>
    <Icon name='notifications' />
    <span className={'bubble ' + bubbleState}>{totalCount}</span>
  </button>
)

const ShoppingButton = ({ count, onClick, bubbleState }) => (
  <button className='action' onClick={onClick}>
    <Icon name='shopping-bag' />
    <span className={'bubble ' + bubbleState}>{count}</span>
  </button>
)

const HeaderRegular = props => {
  const shouldDisplayNotificationButton =
    props.isUserLoggedIn &&
    Boolean(props.outbidItemsCount || props.winningItemsCount)

  return (
    <header className='main-header'>
      <div className='header-main'>
        <MainMenuButton onClick={props.onMainMenuClick} />
        <Logo />
      </div>
      <div className='header-actions'>
        {shouldDisplayNotificationButton && (
          <NotificationsButton
            totalCount={props.outbidItemsCount + props.winningItemsCount}
            bubbleState={getBubbleState(props.outbidItemsCount)}
            onClick={props.onNotificationButtonClick}
          />
        )}
        {Boolean(props.pendingCheckoutCount) && (
          <ShoppingButton
            count={props.pendingCheckoutCount}
            onClick={props.onShoppingButtonClick}
            bubbleState={getBubbleState(props.pendingCheckoutError)}
          />
        )}
        {/*
        <button className='action'>
          <Icon name='search' />
        </button>
        */}
        <button className='action' onClick={props.onUserMenuClick}>
          <Icon name='user-profile' />
        </button>
      </div>
    </header>
  )
}

HeaderRegular.propTypes = {
  isUserLoggedIn: PropTypes.bool,
  winningItemsCount: PropTypes.number,
  outbidItemsCount: PropTypes.number,
  pendingCheckoutCount: PropTypes.number,
  pendingCheckoutError: PropTypes.bool,
  onMainMenuClick: PropTypes.func,
  onUserMenuClick: PropTypes.func,
  onNotificationButtonClick: PropTypes.func,
  onShoppingButtonClick: PropTypes.func
}

HeaderRegular.defaultProps = {
  isUserLoggedIn: true,
  winningItemsCount: 0,
  outbidItemsCount: 0,
  pendingCheckoutCount: 0
}

export default HeaderRegular



// WEBPACK FOOTER //
// ./src/ui/header/header-regular.js